import { Flex } from 'antd';
import styles from './no-records.module.scss';
import Icon from '@ant-design/icons';
import NoRecordsImage from '@/assets/images/gradient-statistic.svg?react';
import clsx from 'clsx';
import { useTranslation } from 'react-i18next';

interface NoRecordsProps {
  description?: string;
  className?: string;
}

export function NoRecords({ description, className }: NoRecordsProps) {
  const { t } = useTranslation('common');

  return (
    <Flex
      vertical
      align="center"
      gap={8}
      className={clsx(styles.container, className)}
      justify="center"
    >
      <Icon component={() => <NoRecordsImage />} />
      <p className={styles.title}>{t('states.noRecords')}</p>
      {description && <p className={styles.description}>{description}</p>}
    </Flex>
  );
}
